import React from "react";
import { useField } from "formik";
import CountrySelectBox from "../CountrySelectBox";

const FormCountrySelectBox = ({ name, onChange = null, ...rest }) => {
  const [field, meta, helpers] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  return (
    <CountrySelectBox
      name={name}
      value={field.value}
      onChange={onChange ?? ((selected) => helpers.setValue(selected[0]))}
      error={getError()}
      {...rest}
    />
  );
};

export default FormCountrySelectBox;
